var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"icon":"","color":"primary darken-3"},on:{"click":_vm.$listeners.click}},'v-btn',_vm.$attrs,false),on),[_c('v-icon',[_vm._v("history")])],1)]}}])},[_c('span',[_vm._v("履歴")])])}
var staticRenderFns = []

export { render, staticRenderFns }